import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTitle from '../../../components/newsTitle';
import NewsList from '../../../components/newsList';
import NewsBox from '../../../components/newsBox';

class CenterNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { fashionTitle, fashionList0, shopInFashion, fashionList1 },
        } = this.props;

        return (
            <div className={styles.center_box}>
                <Chip id="200142" type="struct" title="时尚标题" groupName="时尚" content={fashionTitle}>
                    <NewsTitle size="middle" />
                </Chip>
                <Chip
                    id="225753"
                    type="recommend"
                    title="时尚列表1"
                    groupName="时尚"
                    content={fashionList0}
                    translate="handleNewsData">
                    <NewsList hasTitleImg size="long" />
                </Chip>
                <Chip
                    id="225754"
                    type="recommend"
                    title="时尚区电商"
                    groupName="时尚"
                    content={shopInFashion}
                    translate="handleNewsData">
                    <NewsList size="long" />
                </Chip>
                <Chip
                    id="195868"
                    type="recommend"
                    title="时尚列表2"
                    groupName="时尚"
                    content={fashionList1}
                    translate="handleNewsData">
                    <NewsList size="long" />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(CenterNewsBox);
